<template>
  <v-tooltip bottom color="#2C2C2C">
    <template v-slot:activator="{ on, attrs }">
      <button
        v-if="openModal"
        type="button"
        v-bind="attrs"
        v-on="on"
        @click.stop="openModal"
        class="buttonShow"
      >
        <v-icon v-if="vIcon" :color="$vuetify.breakpoint.smAndDown ? 'white' : '#2F80ED'">{{
          vIcon
        }}</v-icon>
        <svg
          v-else
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0.846924C7.41454 0.846924 3.25621 3.35567 0.187788 7.43054C-0.0625959 7.76438 -0.0625959 8.23078 0.187788 8.56463C3.25621 12.6444 7.41454 15.1532 12 15.1532C16.5855 15.1532 20.7438 12.6444 23.8122 8.56954C24.0626 8.23569 24.0626 7.76929 23.8122 7.43545C20.7438 3.35567 16.5855 0.846924 12 0.846924ZM12.3289 13.0372C9.28506 13.2286 6.7714 10.7199 6.96287 7.6711C7.11998 5.15745 9.15741 3.12001 11.6711 2.96291C14.7149 2.77144 17.2286 5.28019 17.0371 8.32897C16.8751 10.8377 14.8377 12.8752 12.3289 13.0372ZM12.1767 10.7101C10.537 10.8132 9.18196 9.46306 9.28997 7.8233C9.37343 6.46828 10.4732 5.37347 11.8282 5.2851C13.4679 5.182 14.823 6.5321 14.7149 8.17187C14.6266 9.5318 13.5268 10.6266 12.1767 10.7101Z"
            fill="#2F80ED"
          />
        </svg>
      </button>
      <button
        v-else-if="toName"
        @click.stop="$router.push({ name: toName, params: { id: toParams } })"
        v-bind="attrs"
        v-on="on"
        class="buttonShow"
      >
        <v-icon v-if="vIcon" :color="$vuetify.breakpoint.smAndDown ? 'white' : '#2F80ED'">{{
          vIcon
        }}</v-icon>
        <svg
          v-else
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0.846924C7.41454 0.846924 3.25621 3.35567 0.187788 7.43054C-0.0625959 7.76438 -0.0625959 8.23078 0.187788 8.56463C3.25621 12.6444 7.41454 15.1532 12 15.1532C16.5855 15.1532 20.7438 12.6444 23.8122 8.56954C24.0626 8.23569 24.0626 7.76929 23.8122 7.43545C20.7438 3.35567 16.5855 0.846924 12 0.846924ZM12.3289 13.0372C9.28506 13.2286 6.7714 10.7199 6.96287 7.6711C7.11998 5.15745 9.15741 3.12001 11.6711 2.96291C14.7149 2.77144 17.2286 5.28019 17.0371 8.32897C16.8751 10.8377 14.8377 12.8752 12.3289 13.0372ZM12.1767 10.7101C10.537 10.8132 9.18196 9.46306 9.28997 7.8233C9.37343 6.46828 10.4732 5.37347 11.8282 5.2851C13.4679 5.182 14.823 6.5321 14.7149 8.17187C14.6266 9.5318 13.5268 10.6266 12.1767 10.7101Z"
            fill="#2F80ED"
          />
        </svg>
      </button>
      <button v-else v-bind="attrs" v-on="on" class="buttonShow">
        <v-icon v-if="vIcon" :color="$vuetify.breakpoint.smAndDown ? 'white' : '#2F80ED'">{{
          vIcon
        }}</v-icon>
        <svg
          v-else
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0.846924C7.41454 0.846924 3.25621 3.35567 0.187788 7.43054C-0.0625959 7.76438 -0.0625959 8.23078 0.187788 8.56463C3.25621 12.6444 7.41454 15.1532 12 15.1532C16.5855 15.1532 20.7438 12.6444 23.8122 8.56954C24.0626 8.23569 24.0626 7.76929 23.8122 7.43545C20.7438 3.35567 16.5855 0.846924 12 0.846924ZM12.3289 13.0372C9.28506 13.2286 6.7714 10.7199 6.96287 7.6711C7.11998 5.15745 9.15741 3.12001 11.6711 2.96291C14.7149 2.77144 17.2286 5.28019 17.0371 8.32897C16.8751 10.8377 14.8377 12.8752 12.3289 13.0372ZM12.1767 10.7101C10.537 10.8132 9.18196 9.46306 9.28997 7.8233C9.37343 6.46828 10.4732 5.37347 11.8282 5.2851C13.4679 5.182 14.823 6.5321 14.7149 8.17187C14.6266 9.5318 13.5268 10.6266 12.1767 10.7101Z"
            fill="#2F80ED"
          />
        </svg>
      </button>
    </template>
    <span>{{
      pdf
        ? localStorage.translations.pages.common['buttons']['prosmotr'] + ' PDF'
        : localStorage.translations.pages.common['buttons']['prosmotr']
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ButtonShow',
  components: {},
  props: ['vBind', 'vOn', 'openModal', 'toName', 'toParams', 'pdf', 'vIcon'],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.buttonShow {
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    .arrow-5 {
      display: block;
    }
    svg:deep() {
      path {
        fill: #277faf;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 0 !important;
    background: #277faf;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    svg:deep() {
      path {
        fill: #ffffff;
      }
    }
    &:hover {
      opacity: 0.9;
      svg:deep() {
        path {
          fill: #ffffff;
        }
      }
    }
  }
}
</style>
